import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import api from '../commonJs/http.js'
import base64 from '../commonJs/base64'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import menu from '../router/menu.js'
import authorization from '../router/authorization.js'
import Main from '../views/Main.vue'

Vue.use(VueRouter)
//element UI导航栏中的vue-router在3。0以上版本的重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

NProgress.configure({
  showSpinner: false
}) // 禁用加载环


let routes = [{
  path: '/',
  name: 'Main',
  component: Main,
  children: [{
    path: '/Layout',
    name: "Layout",
    component: () => import('../views/IframeLayout/Layout'),
    meta: {
      desc: '用来嵌套第三方页面'
    }
  },
  //这里添加业务路由
  {
    path: '/Map/index',
    name: "MapIndex",
    component: () => import('../views/Map/index'),
    meta: {
      desc: '首页'
    }
  }, {
    path: '/DataAnalysis/SingleAnalysis',
    name: "SingleAnalysis",
    component: () => import('../views/DataAnalysis/SingleAnalysis'),
    meta: {
      desc: '单断面多指标统计'
    }
  }, {
    path: '/DataAnalysis/MoreAnalysis',
    name: "MoreAnalysis",
    component: () => import('../views/DataAnalysis/MoreAnalysis'),
    meta: {
      desc: '多断面单指标统计'
    }
  }, {
    path: '/DataWater/WaterIndex',
    name: "WaterIndex",
    component: () => import('../views/DataWater/WaterIndex'),
    meta: {
      desc: '水质一览'
    }
  }, {
    path: '/DataManage/StaionInfo',
    name: "StationInfo",
    component: () => import('../views/DataManage/StationInfo'),
    meta: {
      desc: '断面信息'
    }
  }, {
    path: '/DataManage/RiverInfo',
    name: "RiverInfo",
    component: () => import('../views/DataManage/RiverInfo'),
    meta: {
      desc: '功能区划信息'
    }
  }, {
    path: '/DataManage/WaterInfo',
    name: "WaterInfo",
    component: () => import('../views/DataManage/WaterInfo'),
    meta: {
      desc: '水质信息'
    }
  }, {
    path: '/DataManage/SewageInfo',
    name: "SewageInfo",
    component: () => import('../views/DataManage/SewageInfo'),
    meta: {
      desc: '污水处理厂信息'
    }
  }, {
    path: '/DataManage/CompanyInfo',
    name: "CompanyInfo",
    component: () => import('../views/DataManage/CompanyInfo'),
    meta: {
      desc: '污染企业信息'
    }
  },

  ]
},

{
  path: '/NoAuth',
  name: 'NoAuth',
  component: () => import('../views/ErrorPage/401.vue')
},
{
  path: '/Error',
  name: 'Error',
  component: () => import('../views/ErrorPage/500.vue')
},
{
  path: '*',
  name: 'NotFound',
  component: () => import('../views/ErrorPage/404.vue')

}
]

const router = new VueRouter({
  routes: []
})



router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (to.query.NoAuthToken) {
    let userName = base64.decode(base64.decode(to.query.NoAuthToken).split('@@')[0]);
    let password = base64.decode(to.query.NoAuthToken).split('@@')[1];
    api.post("/Main/ValidateUser", {
      userName: userName,
      password: password,
      sysid: _myconfig.sysid
    }, function (res) {
      if (res.code == 200) {
        store.commit("saveToken", res.data);
        //去除传来的token
        let queryParam = {};
        for (var p in to.query) {
          if (p != "NoAuthToken") {
            queryParam[p] = to.query[p];
          }
        }
        next({
          path: to.path,
          query: queryParam
        });
      } else {
        menu.LoadMenu(router, routes, 0, to, next, NProgress);
      }
    }, function () {
      menu.LoadMenu(router, routes, 0, to, next, NProgress);
    });
  } else {
    //登录判断
    if (!authorization.Authorization(to, next)) {
      return
    }
    //加载菜单
    menu.LoadMenu(router, routes, 0, to, next, NProgress);
  }


  //Progress.done();
});

export default router